import React, { useState, useEffect } from "react";
import "./RightPanel.css";
import PRDEditor from "./PRDEditor";
import MobilePreview from "./MobilePreview";

const RightPanel = ({
  sessionId,
  isVisible,
  onClose,
  prdContent,
  onPrdUpdate,
  initialTab = "prd",
  isSending,
}) => {
  const [activeTab, setActiveTab] = useState(initialTab);

  // Update active tab when initialTab changes
  useEffect(() => {
    setActiveTab(initialTab);
  }, [initialTab]);

  if (!isVisible) {
    return null;
  }

  return (
    <div className="right-panel">
      <div className="right-panel-header">
        <div className="right-panel-tabs">
          <button
            className={`tab-button ${activeTab === "prd" ? "active" : ""}`}
            onClick={() => setActiveTab("prd")}
          >
            📝 Product Requirements Document Editor
          </button>
          <button
            className={`tab-button ${activeTab === "preview" ? "active" : ""}`}
            onClick={() => setActiveTab("preview")}
          >
            📱 Preview
          </button>
        </div>
        <button className="close-panel-button" onClick={onClose}>
          ✕
        </button>
      </div>

      <div className="right-panel-content">
        {activeTab === "prd" && (
          <PRDEditor
            sessionId={sessionId}
            prdContent={prdContent}
            onPrdUpdate={onPrdUpdate}
          />
        )}
        {activeTab === "preview" && (
          <MobilePreview
            sessionId={sessionId}
            onClose={onClose}
            isSending={isSending}
          />
        )}
      </div>
    </div>
  );
};

export default RightPanel;
